export default __webpack_public_path__ + "static/media/x.9be7c4d3.svg";